import { useAuth } from "@/contexts/AuthContext";
import SocialConnectionsWidget from "@/components/SocialConnectionsWidget";

export default function ClientSocialPage() {
  const { user } = useAuth();

  return (
    <div className="space-y-6" data-testid="client-social-page">
      <div>
        <h1 className="text-2xl font-bold text-white">Mes Reseaux Sociaux</h1>
        <p className="text-[#64748b] text-sm mt-1">Statut de vos comptes reseaux sociaux geres par GLOTECH</p>
      </div>

      <SocialConnectionsWidget clientId={user?.client_id} readOnly={false} />

      <div className="bg-[#151B2B] rounded-xl p-6 border border-[#2A3441]">
        <h3 className="text-white font-semibold mb-2">Comment connecter un reseau ?</h3>
        <p className="text-[#94A3B8] text-sm">
          Cliquez sur "Connecter" pour ajouter votre profil. Entrez le nom et l'URL de votre page.
          Pour toute aide, contactez votre agence GLOTECH.
        </p>
        <div className="flex flex-wrap gap-4 text-sm mt-3">
          <a href="tel:0781559050" className="text-[#0099CC] hover:underline">07 81 55 90 50</a>
          <a href="mailto:comptaglotech@gmail.com" className="text-[#0099CC] hover:underline">comptaglotech@gmail.com</a>
        </div>
      </div>
    </div>
  );
}
